<script>
  import PreviewsThemeOptions from './PreviewsThemeOptions.svelte'
	import PreviewsSortOptions from './PreviewsSortOptions.svelte'
  import PreviewsSizeStepper from "./PreviewsSizeStepper.svelte"
  import PreviewsTrackingStepper from './PreviewsTrackingStepper.svelte'
  import PreviewsFilterSummary from './PreviewsFilterSummary.svelte'
  import { preview_mode, previews_scrolled_up } from './../stores.js'

  export let filtered_preview_count
  export let selected_preview_count

</script>

<div class="viewOptions" class:in_view={$previews_scrolled_up}>
  <div class="left">
    <PreviewsFilterSummary 
    {filtered_preview_count} 
    {selected_preview_count} 
    compact = {$previews_scrolled_up}
    on:deselectAllFonts 
    on:selectAllFonts/>
  </div>
  <div class="center">
    <PreviewsSizeStepper/>
    {#if $preview_mode !== 'letters'}
      <PreviewsTrackingStepper/>
    {/if}
    <PreviewsThemeOptions/>
    <PreviewsSortOptions/>
  </div>
  <div class="right"></div>
</div>

<style>
  .viewOptions {
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: -6rem;
    padding: 1rem 2rem;
    margin-bottom: -2rem;  
    background-color: var(--c-bg);
    font-family: var(--PensumSans);
    font-size: 1.6rem;
    line-height: 4rem;
    letter-spacing: -0.01rem;
    transition-property: background-color, top;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-function);
  }

  .viewOptions .left,
  .viewOptions .center {
    display: flex;
  }
  .viewOptions .right {
    display: none;
  }

  .viewOptions.in_view {
    top: 0rem;
    z-index: 2;
    box-shadow: var(--box-shadow);
  }
  .viewOptions.in_view .right {
    display: flex;
  }
  .viewOptions.in_view :is(.left, .right) {
    flex: 1;
  }

  @media only screen and (max-width: 840px) {
    .viewOptions {
      display: block;
    }
    .viewOptions .center,
    .viewOptions .left {
      display: inline-block;
    }

    .viewOptions .center :global(div) {
      display: inline-block;
      margin-right: 3rem;
    }
  }
</style>